import { formatDecimal } from '@/lib/format';
import type { AtRiskReasonDto } from '../types';

/**
 * Translate a machine reason code (`missing_homework` | `low_attendance` |
 * `low_average`) into the "value vs threshold" sentence. The codes are the
 * server's; they are never rendered raw.
 */
export function reasonText(
  reason: AtRiskReasonDto,
  t: (key: string, options?: Record<string, unknown>) => string
): string {
  return t(`progress:atRisk.reasons.${reason.code}`, {
    value: formatDecimal(reason.value),
    threshold: formatDecimal(reason.threshold),
  });
}
